module.exports = __webpack_public_path__ + "img/img_04.faa58fe4.webp";